
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "xmlns:a": "http://ns.adobe.com/AdobeSVGViewerExtensions/3.0/",
    "x": "0px",
    "y": "0px",
    "width": "140px",
    "height": "141px",
    "viewBox": "0 -0.5 140 141",
    "enable-background": "new 0 -0.5 140 141",
    "xml:space": "preserve"
  },
  "children": [
    {
      "tag": "defs"
    },
    {
      "tag": "rect",
      "attrsMap": {
        "display": "none",
        "fill": "#F2F2F2",
        "width": "140",
        "height": "140"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "fill": "none",
        "stroke": "#B4B4B5",
        "stroke-width": "2",
        "stroke-miterlimit": "10",
        "d": "M26.233,104.801V31.468c0,0,1-3.667,4.668-3.667\r\n\th80.666c0,0,3.666,1.333,3.666,6.333v12.667h-9"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "fill": "none",
        "stroke": "#B4B4B5",
        "stroke-width": "2",
        "stroke-miterlimit": "10",
        "d": "M21.9,126.467c0,0-4.333,0.667-4.333-4v-16H94.9\r\n\tV119.8c0,0,1.667,2.667,5.333,3c3.667,0.334,6-1.967,5-6.317c-1-4.349,0-81.683,0-81.683s0.736-3.225,5-3.666\r\n\tc4.266-0.441,5,0.333,5,3"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "fill": "none",
        "stroke": "#B4B4B5",
        "stroke-width": "2",
        "stroke-miterlimit": "10",
        "d": "M19.9,126.5h81.667c0,0,3.8-0.016,3.624-6.382"
      }
    },
    {
      "tag": "line",
      "attrsMap": {
        "fill": "none",
        "stroke": "#B4B4B5",
        "stroke-width": "2",
        "stroke-miterlimit": "10",
        "x1": "8.874",
        "y1": "38.834",
        "x2": "16.94",
        "y2": "38.834"
      }
    },
    {
      "tag": "line",
      "attrsMap": {
        "fill": "none",
        "stroke": "#B4B4B5",
        "stroke-width": "2",
        "stroke-miterlimit": "10",
        "x1": "12.907",
        "y1": "35.248",
        "x2": "12.907",
        "y2": "42.718"
      }
    },
    {
      "tag": "line",
      "attrsMap": {
        "fill": "none",
        "stroke": "#B4B4B5",
        "stroke-width": "2",
        "stroke-miterlimit": "10",
        "x1": "54.323",
        "y1": "10.434",
        "x2": "62.39",
        "y2": "10.434"
      }
    },
    {
      "tag": "line",
      "attrsMap": {
        "fill": "none",
        "stroke": "#B4B4B5",
        "stroke-width": "2",
        "stroke-miterlimit": "10",
        "x1": "58.356",
        "y1": "6.849",
        "x2": "58.356",
        "y2": "14.317"
      }
    },
    {
      "tag": "rect",
      "attrsMap": {
        "x": "38.298",
        "y": "36.248",
        "fill": "#D7D7D8",
        "width": "55.885",
        "height": "22.519"
      }
    },
    {
      "tag": "rect",
      "attrsMap": {
        "x": "38.856",
        "y": "67.934",
        "fill": "#D7D7D8",
        "width": "49",
        "height": "4"
      }
    },
    {
      "tag": "rect",
      "attrsMap": {
        "x": "38.856",
        "y": "85.6",
        "fill": "#D7D7D8",
        "width": "42.885",
        "height": "4"
      }
    },
    {
      "tag": "rect",
      "attrsMap": {
        "x": "38.856",
        "y": "76.767",
        "fill": "#D7D7D8",
        "width": "30.609",
        "height": "4"
      }
    },
    {
      "tag": "line",
      "attrsMap": {
        "fill": "none",
        "stroke": "#B4B4B5",
        "stroke-width": "2",
        "stroke-miterlimit": "10",
        "x1": "127.934",
        "y1": "26.24",
        "x2": "136",
        "y2": "26.24"
      }
    },
    {
      "tag": "line",
      "attrsMap": {
        "fill": "none",
        "stroke": "#B4B4B5",
        "stroke-width": "2",
        "stroke-miterlimit": "10",
        "x1": "131.967",
        "y1": "22.655",
        "x2": "131.967",
        "y2": "30.124"
      }
    }
  ]
})
    }
  